import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

const AlertDialog = ({ IconComponent, warningMessage, onYesClick, onNoClick ,visible}) => {
  const handleClose = () => {
    // Optional: Handle dialog close event if needed
  };

  const handleYesClick = () => {
    if (onYesClick) {
      onYesClick();
    }
    handleClose();
  };

  const handleNoClick = () => {
    if (onNoClick) {
      onNoClick();
    }
    handleClose();
  };

  return (
    <Dialog open={visible??false} onClose={handleClose}>
      <DialogTitle>Warning</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {IconComponent??null}{warningMessage}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleNoClick} color="primary">
          No
        </Button>
        <Button onClick={handleYesClick} color="primary" autoFocus>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialog;
